module.exports = __webpack_public_path__ + "img/artboard9.4e563df3.png";